import { useState, useEffect, ReactElement, forwardRef } from 'react';
import styles from './index.module.sass';
import classname from 'classnames/bind';
import DialogLayout from '../dialog-layout/dialog-layout';
import LoadingMochi from '../loading-mochi/loading-mochi';
const cx = classname.bind(styles);

interface buttonItemProps {
  theme: 'positive' | 'negative' | 'cancel';
  content: string | React.ReactNode;
  beLoading?: boolean;
  onClick?: () => void;
}

interface buttonDialogProps {
  image?: string;
  title?: React.ReactNode | string;
  message?: ReactElement | string;
  buttonList: Array<buttonItemProps>;
  show: boolean;
  withClose?: boolean;
  onDismiss?: any;
  className?: string;
}

const ButtonDialog = forwardRef(
  (
    {
      image,
      title,
      message,
      buttonList = [],
      show = false,
      withClose,
      onDismiss,
      className,
    }: buttonDialogProps,
    ref: any,
  ) => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      if (!show) {
        setLoading(show);
      }
    }, [show]);

    const DialogButton = ({ item }: any) => {
      const buttonClasses = cx({
        button: true,
        'positive-btn': item.theme === 'positive',
        'negative-btn': item.theme === 'negative',
        'close-btn': item.theme === 'cancel',
      });

      return (
        <div
          className={buttonClasses}
          onClick={() => {
            if (item.onClick) {
              if (item.beLoading) {
                setLoading(true);
              }
              item.onClick();
            }
          }}
        >
          {item.content}
        </div>
      );
    };

    const messageContent = () => {
      if (
        typeof message === 'string' &&
        (message.includes('\r') || message.includes('\n'))
      ) {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: message.replace(/(?:\r\n|\r|\n)/g, '<br>'),
            }}
          />
        );
      }
      return message;
    };

    const buttonDialogClass = cx({
      'button-dialog': true,
      'is-loading': loading,
    });

    const buttonGroupClass = cx({
      'button-group': true,
      horizonal: buttonList.length <= 2,
    });

    return (
      <DialogLayout
        show={show}
        onDismiss={onDismiss}
        withClose={withClose}
        ref={ref}
      >
        <>
          <LoadingMochi show={loading} />
          <div className={`${buttonDialogClass} ${className}`}>
            {image && (
              <div className={styles.image}>
                <img src={image} alt="image" />
              </div>
            )}
            <div className={styles.title}>{title}</div>
            {message && (
              <div className={styles.message}>{messageContent()}</div>
            )}
            <div className={buttonGroupClass}>
              {buttonList.map((item, index) => {
                return <DialogButton key={index} item={item} />;
              })}
            </div>
          </div>
        </>
      </DialogLayout>
    );
  },
);

export default ButtonDialog;
